var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 6092,
    viewBox: "0 0 1440 6092",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_10)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1077.29,
    cy: 2629.08,
    rx: 268.153,
    ry: 63.5565,
    transform: "rotate(-22.8137 1077.29 2629.08)",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.003,
    cy: 1748.76,
    rx: 115.003,
    ry: 99.3412,
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1003.26,
    cy: 3345.38,
    rx: 85.9167,
    ry: 74.2822,
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.728,
    cy: 4409.5,
    rx: 114.556,
    ry: 119.03,
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1175.88,
    cy: 4904.38,
    rx: 196.241,
    ry: 65.9776,
    transform: "rotate(15 1175.88 4904.38)",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.537,
    cy: 5742.38,
    rx: 207.632,
    ry: 61.7409,
    transform: "rotate(-15 471.537 5742.38)",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.987,
    cy: 108.291,
    rx: 175.861,
    ry: 108.291,
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_131_10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1242.21,
    cy: 870.802,
    rx: 116.346,
    ry: 100.236,
    fill: "#88FCAF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_131_10",
    x: 409.309,
    y: 2090.16,
    width: 1335.96,
    height: 1077.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_131_10",
    x: -419.56,
    y: 1229.86,
    width: 1069.13,
    height: 1037.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_131_10",
    x: 497.78,
    y: 2851.54,
    width: 1010.95,
    height: 987.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_131_10",
    x: -361.387,
    y: 3870.91,
    width: 1068.23,
    height: 1077.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_131_10",
    x: 565.985,
    y: 4403.32,
    width: 1219.79,
    height: 1002.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_131_10",
    x: -149.226,
    y: 5242.54,
    width: 1241.53,
    height: 999.676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_131_10",
    x: -335.433,
    y: -419.559,
    width: 1190.84,
    height: 1055.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_131_10",
    x: 706.307,
    y: 351.006,
    width: 1071.81,
    height: 1039.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 209.78,
    result: "effect1_foregroundBlur_131_10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6092,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdrop);
export default __webpack_public_path__ + "static/media/backdrop.6eb6f92bcd592647074699b58979d590.svg";
export { ForwardRef as ReactComponent };